// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1IEg4","signatureButtonsRight":"ModalSign_signatureButtonsRight__3tea2"};